module.exports = __webpack_public_path__ + "assets/sounds/jingle-bells.mp3";